import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import Adulte from "./Adulte";
import Enfant from "./Enfant";
import Inscription from "./Inscription";

Vue.use(Vuex);

export default new Vuex.Store({
  // state: {},
  // getters: {},
  // mutations: {},
  // actions: {},
  modules: {
    Adulte,
    Enfant,
    Inscription,
  },
  plugins: [
    createPersistedState({
      paths: ["Enfant", "Adulte"],
      storage: window.sessionStorage,
    }),
  ],
});
